module.exports = __webpack_public_path__ + "static/board-02-5e21246ed438ec0102fb0130bb2a82b8.jpg";